<template>
    <b-card>
        <div class="d-flex title-bar-block assets-vendor-view mb-4">
            <div class="icon-block me-4">
                <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('asset_vendor') }}</span>
            </div>
        </div>
        <b-card-body class="p-0">
            <b-overlay :show="loading" rounded="sm">
                <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                    <b-row>
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $translate('name') }}<span class="red">*</span></strong></label>
                            <b-form-input type="text" id="input-name" v-model="model.name" required
                                v-custom-validation="$textRequired()" :placeholder="$translate('enter_name')"
                                trim></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('description') }}</strong></label>
                            <b-form-input type="text" id="input-description" v-model="model.description"
                                :placeholder="$translate('enter_description')" trim></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('notes') }}</strong></label>
                            <b-form-textarea id="input-notes" name="TaskNotes" :placeholder="$translate('enter_notes')"
                                v-model="model.notes" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="my-3 filter-form asset-vendor-customer">
                            <label class="mb-3"><strong>{{ $translate('vendor_code') }}</strong></label>
                            <customer-type-ahead v-model="model.customer_id" 
                                ></customer-type-ahead>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="mt-4 text-center">

                            <b-button class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                                variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                            <b-button class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                                variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                            <b-button class="me-2" v-if="model.id && hasPermissionDelete" size="fw" v-show="hasPermissionDelete"
                                @click="deleteVendor()" variant="delete-button">
                                {{ $translate('delete_vendor') }}
                            </b-button>
                            <b-button variant="info" size="fw" :disabled="loading ? true : false" @click="cancel()">{{
                                $cancelLabel() }}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-overlay>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import CustomerTypeAhead from '@/components/CustomerTypeAhead.vue'

export default {
    name: 'assetVendors-View',
    components: {
        CustomerTypeAhead,
    },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            title: 'Asset-Vendor',
            loading: false,
            model: {
                id: 0,
                name: null,
                notes:null,
                customer_id:null,
                description: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = model.id
                ? 'assets/updateVendor'
                : 'assets/createVendor'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const action = model.id ? this.$translate('updated') : this.$translate('created')
                            const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
                            this.$emit('success', action, model.name, message)
                        })
                        .catch(error => {
                            this.$emit('error', error, model.name)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteVendor() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'assets/deleteVendor'
            const action = model.id ? 'update' : 'create'
            // Generate and display confirmation prompt
            const title = this.$translate('delete_vendor_title')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = this.$translate('unable_alert')
            const alertMsg = this.$translate('delete_alert')

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                model.name,
                                alertMsg,
                                action
                            );
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                // this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
    },
}
</script>
<style></style>
